// JSON requests for the Stimulus controllers.
//
// The sprockets code got its CSRF token for free from jquery_ujs' ajax prefilter;
// fetch() does not. ApplicationController uses `protect_from_forgery with: :null_session`,
// so a missing token does NOT raise - the request silently runs against a fresh guest
// session and the write lands in the wrong cart. Always send the token.

export function putJson(url, params) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  // fail loudly instead of sending the literal string "undefined", which
  // null_session would accept as a guest and book into the wrong cart
  if (!token) return Promise.reject(new Error("CSRF meta tag missing"));
  const body = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") body.append(key, value);
  });

  return fetch(url, {
    method: "PUT",
    body,
    credentials: "same-origin",
    headers: {
      "X-CSRF-Token": token,
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json",
    },
  }).then((response) => {
    if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
    return response.json();
  });
}
